// extracted by mini-css-extract-plugin
module.exports = {"welcome-title":"homePage_welcome-title__ePhjB"};